import { render, staticRenderFns } from "./CalendarEditForm.vue?vue&type=template&id=3a37c436&scoped=true"
import script from "./CalendarEditForm.vue?vue&type=script&lang=js"
export * from "./CalendarEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a37c436",
  null
  
)

export default component.exports